import React, { FC, useEffect, useRef, useState } from 'react';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';

interface Props {
  queSet: any;
  queState: any;
  setQueState: any;
  awsState: any;
  setAwsState: any;
}

const QuestionBox: FC<Props> = ({ queSet, queState, setQueState, awsState, setAwsState }) => {
  const btnStyle = {
    fontWeight: '600',
    width: '150px',
    height: '34px',
    fontSize: '14px',
    lineHeight: '14px',
  };

  const confirmEvt = (item: any, status: any) => {
    const queSet = queState.set || [];
    const idx = item.idx;

    const nextSet = item.confirmSet?.[status];
    const nextSeq = nextSet.nextSeq;
    const currentPass = nextSet.pass;
    console.log('nextSeq:::', nextSeq, currentPass);

    queSet.forEach((item: any) => {
      if (item.idx === idx) {
        item.passed = currentPass;
        item.status = 'end';
        item.confirm = status;
      }
      if (item.idx === nextSeq) {
        if (item.status !== 'end') item.status = 'this';
      }
    });

    if (nextSeq === 'end') {
      queSet.forEach((qitem: any) => {
        if (qitem.status === 'ready') {
          qitem.status = 'cancle';
          qitem.pass = 'fail';
          qitem.confirm = status;
        }
      });
    }
    setQueState({ set: queSet });
  };

  const resetEvt = (idx: any) => {
    const queSet = queState.set || [];
    queSet.forEach((item: any) => {
      if (item.status === 'this') item.status = 'end';
      if (item.idx === idx) {
        item.status = 'this';
      }
    });
    setQueState({ set: queSet });
  };

  const questionSet = () => {
    return (
      <div className="_question_set">
        {queState.set.map((item: any, idx: number) => {
          const question = item.set.question || '';
          const confirm = item.confirm || '';
          let confirmStatus = '';
          if (confirm === 'Y') confirmStatus = '네';
          if (confirm === 'N') confirmStatus = '아니오';

          const desc = item.set?.desc?.data || [];
          const boxStyle = item.set?.style || {};
          const itemIdx: number = item.idx || 0;
          const viewStatus = item.status || '';
          return (
            <div
              className={['_que_box', viewStatus].join(' ')}
              key={idx}
              onClick={e => (viewStatus === 'end' ? resetEvt(idx) : '')}
            >
              <div className="_item" style={boxStyle}>
                <div className="_bg"></div>
                <div className="_que_div">
                  <div className="_icon">
                    <i className="ri-question-line" />
                  </div>
                  <div className="_text">{question}</div>
                  {viewStatus === 'end' && confirm !== '' ? (
                    <div className={['_confirm', confirm].join(' ')}>{confirmStatus}</div>
                  ) : (
                    ''
                  )}
                </div>
                {desc.length > 0 ? (
                  <div className={['_des_div'].join(' ')}>
                    {desc.map((desItem: any, dIdx: number) => {
                      return (
                        <div className="_des_item" key={dIdx}>
                          <div className="_icon"></div>
                          {desItem.text}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  ''
                )}
                <div className="_btn_div">
                  <div className="_btn">
                    <DefaultButton
                      icon=""
                      clickEvent={e => confirmEvt(item, 'Y')}
                      type="type3"
                      text="네"
                      styleDef={btnStyle}
                    />
                  </div>
                  <div className="_btn">
                    <DefaultButton
                      icon=""
                      clickEvent={e => confirmEvt(item, 'N')}
                      type="type2"
                      text="아니오"
                      styleDef={btnStyle}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  const answerSet = () => {
    const answerSet: any = awsState.set || {};
    const answerStatus = answerSet.status || '';
    const boxStyle = answerSet.style || {};

    const title = answerSet.set?.title || '';
    const desc = answerSet?.set?.desc?.data || [];
    const status = answerSet?.set?.status || '';

    return (
      <div className="_answer_set">
        {answerStatus === 'end' ? (
          <div className={['_answer_box'].join(' ')}>
            <div className="_item" style={boxStyle}>
              <div className="_bg"></div>
              <div className={['_title_div', status].join(' ')}>
                <div className="_icon">
                  <i className="ri-checkbox-circle-line" />
                </div>
                <div className="_text">{title}</div>
              </div>
              {desc.length > 0 ? (
                <div className={['_des_div'].join(' ')}>
                  {desc.map((desItem: any, dIdx: number) => {
                    return (
                      <div className={['_des_item'].join(' ')} key={dIdx}>
                        <div className="_icon"></div>
                        {desItem.text}
                      </div>
                    );
                  })}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  };

  return (
    <div className="_question_div_ne_component">
      <div className="_box">{questionSet()}</div>
      <div className="_box">{answerSet()}</div>
    </div>
  );
};

export default QuestionBox;
